import React from 'react';

import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';
import { BaseConfirmationModal } from 'src/modals/common';

export type UndergoReverificationConfirmationModalArgs = {
  onSubmit: () => void;
};

export const UndergoReverificationConfirmationModal: React.FC = () => {
  const { args, closeModal, isOpen } = useModal<UndergoReverificationConfirmationModalArgs>(
    ModalId.UndergoReverificationConfirmationModal,
  );

  const {
    onSubmit = () => {
      return null;
    },
  } = args ?? {};

  const onCloseModal = React.useCallback(() => {
    closeModal(ModalId.UndergoReverificationConfirmationModal);
  }, [closeModal]);

  const onSubmitModal = React.useCallback(async () => {
    await onSubmit();
    onCloseModal();
  }, [onCloseModal, onSubmit]);

  const contentText =
    "By confirming these changes to your company information, your account will undergo reverification. During this process, you will not be able to initiate new verifications until your account's reverification is completed.";

  return (
    <BaseConfirmationModal
      isOpen={isOpen}
      onSubmit={onSubmitModal}
      onClose={onCloseModal}
      maxWidth={477}
      title="Are you sure?"
      contentText={contentText}
      buttonText="Yes, sure"
      actionButtonColor="error"
    />
  );
};
